import React, {useState} from 'react';
import styles from "./admin-term-sheet-details.module.scss";
import {Button, Col, ProgressBar, Row} from "react-bootstrap";
import ConfirmTermSheetModalContent from "../confirm-term-sheet-modal-content/confirm-term-sheet-modal-content";
import ModalCustom from "../../../../../../components/modal/modal";
import RejectTermSheetModalContent from "../reject-term-sheet-modal-content/reject-term-sheet-modal-content";
import {
  getMannerOfDistribution,
  getNumberOfSecurity,
  getSecurityForm,
  getSecurityTypes
} from "../../../../../../helpr/listingFormData";
import {
  TERM_SHEET_CONFIRMED,
  TERM_SHEET_DRAFT,
  TERM_SHEET_REJECTED,
  TERM_SHEET_SUBMITTED
} from "../../../../../../helpr/constants";
import ListingService from "../../../../../../services/listing-service";

const AdminTermSheetDetails = ({context}) => {
  const listingService = new ListingService();
  const [modalState, setModalState] = useState({
    title: '',
    show: false,
    component: '',
    style: ''
  });
  const {termSheet, computePercentage} = context;

  //Modal actions
  const closeModal = () => {
    setModalState(prev => ({
      ...modalState,
      show: false,
      component: '',
      style: prev.style
    }));
  }

  const showConfirmModal = () => {
    const component = <ConfirmTermSheetModalContent context={context} onClose={() => closeModal()} />
    setModalState({
      ...modalState,
      title: "Confirm Term Sheet",
      show: true,
      component: component,
      style: 'administer-term-sheet-modal'
    });
  }
  const showRejectModal = () => {
    const component = <RejectTermSheetModalContent context={context} onClose={() => closeModal()} />
    setModalState({
      ...modalState,
      title: "Reject Term Sheet",
      show: true,
      component: component,
      style: 'administer-term-sheet-modal'
    });
  }

  const downloadExtract = async () => {
    try {
      const resp = await listingService.extractTermSheet(termSheet.applicationId);
      window.open(resp['url']);
    } catch(error){

    }
  }

  const renderTypeValue = key => getSecurityTypes({value: key}).filter(t => t.value === key)[0]?
    getSecurityTypes({value: key}).filter(t => t.value === key)[0].name: key;
  const renderFormValue = key => getSecurityForm().filter(t => t.value === key)[0]?
    getSecurityForm().filter(t => t.value === key)[0].name: key;
  const renderMannerValue = key => getMannerOfDistribution().filter(t => t.value === key)[0].name;
  const renderNumberValue = key => getNumberOfSecurity().filter(t => t.value === key)[0].name;
  const renderStatus = status => {
    switch(status) {
      case TERM_SHEET_DRAFT:
        return 'Draft - Pending Submission';
      case TERM_SHEET_SUBMITTED:
        return 'Submitted';
      case TERM_SHEET_CONFIRMED:
        return 'Confirmed';
      case TERM_SHEET_REJECTED:
        return 'Rejected';
      default:
    }
  }

  return (
    <>
      <div className={`${styles['term-sheet-details']} ${styles['panel']}`}>
        <Row>
          <Col xs={12} lg={6}>
            <div className={styles['table-heading']}>
              Security Terms
            </div>
          </Col>
          <Col xs={12} lg={6}>
            <div className={styles['button-row']}>
              {/* <Button variant="secondary" onClick={()=>{
                if(!letterExtractAvailable()){
                  generateLetters();
                } else {
                  downloadLetters();
                }
              }}>
                { letterGenerationButton() }
              </Button> */}
              {/* <Button variant="secondary" onClick={()=>{
                if(!docExtractAvailable()){
                  generateDocuments();
                } else {
                  downloadDocuments();
                }
              }}>
                { docGenerationButton() }
              </Button> */}
              {termSheet.applicationStatus === '1' ||  termSheet.applicationStatus === '2' ? <Button onClick={() => showRejectModal()} variant="danger">
                REJECT
              </Button> : ''}
              {termSheet.applicationStatus === '1' ?<Button onClick={() => showConfirmModal()}>
                CONFIRM
              </Button> : ''}
              {termSheet.applicationStatus === '2' ?<Button onClick={() => downloadExtract()}>
                DOWNLOAD
              </Button> : ''}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={styles['term-sheet-status']}>
              Status: {renderStatus(termSheet.applicationStatus)}
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <div>
              <ProgressBar className={styles['progress']} now={computePercentage()} label={`${computePercentage()}%`} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Type: <span className={styles['value']}>{renderTypeValue(termSheet.securityType)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Form: <span className={styles['value']}>{renderFormValue(termSheet.securityForm)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Manner of Distribution: <span className={styles['value']}>{renderMannerValue(termSheet.mannerOfDistrib)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Number of Security: <span className={styles['value']}>{renderNumberValue(termSheet.numberOfSecurity)}</span>
            </div>
          </Col>
        </Row>
      </div>
      <ModalCustom
        show={modalState.show}
        title={modalState.title}
        onClose={() => closeModal()}
        component={modalState.component}
        style={modalState.style ? styles[modalState.style] : ''} />
    </>
  )
}

export default  AdminTermSheetDetails;
